import { useScopedAppFlagStore } from '@frontend/scope';
import { featureFlags } from '../../../../feature-flags';
import { NSRRoiLocationsComparisonAppointmentType } from '../charts/nsr-roi-locations-comparison-appointment-type';
import { NSRRoiLocationsComparisonBenchmark } from '../charts/nsr-roi-locations-comparison-benchmark';
import { NSRRoiLocationsComparisonConfirmationStatus } from '../charts/nsr-roi-locations-comparison-confirmation-status';
import { NSRRoiLocationsComparisonDays } from '../charts/nsr-roi-locations-comparison-days';
import { NSRRoiLocationsComparisonPatientType } from '../charts/nsr-roi-locations-comparison-patient-type';

export const NSRRoiDashboardMulti = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isDemoAccount = getFeatureFlagValue(featureFlags.noShowRateRoiDemoData);

  return (
    <>
      <NSRRoiLocationsComparisonBenchmark isDemoAccount={isDemoAccount} />
      <NSRRoiLocationsComparisonPatientType isDemoAccount={isDemoAccount} />
      <NSRRoiLocationsComparisonConfirmationStatus isDemoAccount={isDemoAccount} />
      <NSRRoiLocationsComparisonDays isDemoAccount={isDemoAccount} />
      <NSRRoiLocationsComparisonAppointmentType isDemoAccount={isDemoAccount} />
    </>
  );
};
